import { Color } from "./Color";
import { TextureKinds } from "./TextureKinds";
import { IPaintStyle } from "./IPaintStyle";

export class PaintStyle {
  constructor(public color: Color = new Color("transparent"), public kind: TextureKinds = TextureKinds.None, public additionalTextureKind: TextureKinds = TextureKinds.None) { }

  clone(): PaintStyle {
    return new PaintStyle(
      this.color.clone(),
      this.kind,
      this.additionalTextureKind,
    );
  }

  static from(source: IPaintStyle): PaintStyle {
    // Docu2Webで実装したPaintStyleは仕様誤解によってテクスチャを含んでしまっている.フォーマット編集で実装したIPaintStyleには含めないのでNoneに.
    return new PaintStyle(Color.from(source.color), TextureKinds.None, TextureKinds.None);
  }

  static to(source: PaintStyle): IPaintStyle {
    if (!source) {
      return null;
    }
    return {
      color: {
        value: source.color.value,
      },
    };
  }
}
